<template>
  <!-- prettier-ignore -->
  <basic-select
    v-model="model"
    :disabled="$props.disabled"
    :label="$props.label"
    :name="$props.name"
    :options="genderList"
    :readonly="$props.readonly"
    :v="$props.v"
  />
</template>

<script setup>
import { computed } from 'vue'
import useI18n from '@/hooks/useI18n'

import BasicSelect from '@/components/Basic/Select'

import { GENDER } from '@/config/petConstants'

// HOOKS
const { t } = useI18n()

// INIT
const model = defineModel({ type: [String] })
const props = defineProps({
  age: {
    type: Number,
    default: null,
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  label: {
    type: String,
    default: '',
  },

  modelValue: {
    type: String,
    default: '',
  },

  name: {
    type: String,
    default: 'gender',
  },

  readonly: {
    type: Boolean,
    default: false,
  },

  theme: {
    type: String,
    default: 'transparent',
  },

  v: {
    type: Object,
    default: () => {},
  },
})

// COMPUTED
const genderList = computed(() => {
  return Object.values(GENDER)
    .map(value => {
      return {
        value,
        label: t(`screen.petDetails.petData.gender.${value.toLowerCase()}`),
        disabled: props.disabled,
      }
    })
    .filter(i => !i.disabled)
})
</script>
